<div mat-dialog-title id="phone-dialog-title">
  @if (data.model.number) {
    {{
      'Contacts.Management.Phones.Dialog.PhoneNumberTitle' | translate: locale.language : { number: data.model.number }
    }}
  } @else {
    {{ 'Contacts.Management.Phones.Dialog.NewPhoneNumber' | translate: locale.language }}
  }
</div>
<div mat-dialog-content [attr.aria-labelledby]="'phone-dialog-title'">
  <div>
    <mat-form-field class="full-width" appearance="fill">
      <mat-label>{{ 'Contacts.Management.Phones.Dialog.Number' | translate: locale.language }}</mat-label>
      <input
        matInput
        [required]="true"
        [placeholder]="'Contacts.Management.Phones.Dialog.NumberPlaceholder' | translate: locale.language"
        [(ngModel)]="currentPhoneNumber"
        prefix="+1 "
        mask="(000) 000-0000"
        [showMaskTyped]="true"
        [disabled]="data.action !== 'Create'" />
    </mat-form-field>
  </div>

  @if (!isBackOfficeMode) {
    <div>
      <mat-form-field class="full-width" appearance="fill">
        <mat-label>{{ 'Contacts.Management.Phones.Dialog.Type' | translate: locale.language }}</mat-label>
        <mat-select required [(ngModel)]="currentPhoneType" [disabled]="data.action !== 'Create'">
          @for (type of phoneTypes(); track $index) {
            <mat-option [value]="type">
              {{ typeNameMap[type] }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }

  @if (isEditMode && (data.model.type === 'Cell' || data.model.type === 'Pager')) {
    <div style="display: flex; align-items: center; width: 100%">
      <mat-form-field appearance="fill" style="flex: 1">
        <mat-label>
          {{ 'Contacts.Management.ContactInformation.Phone.SelectProvider' | translate: locale.language }}
        </mat-label>
        <mat-select [(ngModel)]="currentProvider" [disabled]="!canEditProvider">
          @for (provider of providers(); track $index) {
            <mat-option [value]="provider.CellProviderCode">
              {{ provider.CellPhoneDesc }}
            </mat-option>
          }
        </mat-select>
        @if (data.action !== 'Edit') {
          <mat-hint>
            <strong>
              {{ 'Contacts.Management.ContactInformation.Phone.ProviderHint' | translate: locale.language }}
            </strong>
          </mat-hint>
        }
      </mat-form-field>
    </div>
    @if (findProviderError()) {
      <mat-error>
        {{ 'Contacts.Management.ContactInformation.Phone.ProviderError' | translate: locale.language }}
      </mat-error>
    }
  }
  @if (isEditMode || isBackOfficeMode) {
    @if (supportsSms) {
      <div style="display: flex; align-items: center; width: 100%">
        <mat-form-field appearance="fill" style="flex: 1">
          <mat-label>
            {{ 'Contacts.Management.Phones.Dialog.SmsStatus' | translate: locale.language }}
            @if (!currentSmsStatus()) {
              {{ 'Contacts.Management.Phones.Dialog.None' | translate: locale.language }}
            } @else if (isSmsStatusUnsupported()) {
              {{ 'Contacts.Management.Phones.Dialog.Unsupported' | translate: locale.language }}
            } @else {
              {{ statusNameMap[currentSmsStatus()!] }}
            }
          </mat-label>
          <mat-select
            [(value)]="currentSmsStatus"
            [disabled]="!canEditPhone || isSmsStatusUnsupported()"
            aria-describedby="sms-status-description">
            @if (isSmsStatusUnsupported()) {
              <mat-option [value]="'Unsupported'" [disabled]="true" [attr.aria-disabled]="true">
                {{ 'Contacts.Management.Phones.Dialog.Unsupported' | translate: locale.language }}
              </mat-option>
            }
            @for (status of getValidPhoneStatuses(); track $index) {
              <mat-option [value]="status">
                {{ statusNameMap[status] }}
              </mat-option>
            }
          </mat-select>
          <span id="sms-status-description" class="visually-hidden">
            {{ 'Contacts.Management.Phones.Dialog.SmsStatus' | translate: locale.language }}
          </span>
        </mat-form-field>
      </div>
    }
    @if (supportsVoice) {
      <div style="display: flex; align-items: center; width: 100%">
        <mat-form-field appearance="fill" style="flex: 1">
          <mat-label>
            {{ 'Contacts.Management.Phones.Dialog.VoiceStatus' | translate: locale.language }}
            @if (!currentVoiceStatus()) {
              {{ 'Contacts.Management.Phones.Dialog.None' | translate: locale.language }}
            } @else if (isVoiceStatusUnsupported()) {
              {{ 'Contacts.Management.Phones.Dialog.Unsupported' | translate: locale.language }}
            } @else {
              {{ statusNameMap[currentVoiceStatus()!] }}
            }
          </mat-label>
          <mat-select
            [(value)]="currentVoiceStatus"
            [disabled]="!canEditPhone || isVoiceStatusUnsupported()"
            aria-describedby="voice-status-description">
            @if (isVoiceStatusUnsupported()) {
              <mat-option [value]="'Unsupported'" [disabled]="true" [attr.aria-disabled]="true">
                {{ 'Contacts.Management.Phones.Dialog.Unsupported' | translate: locale.language }}
              </mat-option>
            }
            @for (status of getValidPhoneStatuses(); track $index) {
              <mat-option [value]="status">
                {{ statusNameMap[status] }}
              </mat-option>
            }
          </mat-select>
          <span id="voice-status-description" class="visually-hidden">
            {{ 'Contacts.Management.Phones.Dialog.VoiceStatus' | translate: locale.language }}
          </span>
        </mat-form-field>
      </div>
    }
  }

  <div mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close [attr.aria-label]="'Close' | translate: locale.language">
      {{ 'Close' | translate: locale.language }}
    </button>
    @if (canEditPhone) {
      <button
        [disabled]="!canSavePhone()"
        mat-raised-button
        color="primary"
        (click)="onSaveClick()"
        [attr.aria-label]="
          ('Save' | translate: locale.language) +
          (!canSavePhone()
            ? ' - ' + ('Contacts.Management.Phones.Dialog.InvalidPhoneNumber' | translate: locale.language)
            : '')
        ">
        {{ 'Save' | translate: locale.language }}
      </button>
    }
  </div>

  <app-loading [isCircle]="false" [hasLoaded]="hasLoaded()" aria-live="polite"></app-loading>
</div>
